import React, { useCallback } from 'react';
import styled from 'styled-components';
import { FormikValues, useFormikContext } from 'formik';
import FormHelperText from '@material-ui/core/FormHelperText';

import ImagesUploader from 'src/components/Common/ImageUploader';

interface IStyledProps {
  isActive?: boolean;
  loading?: boolean;
}
const Section = styled('section')<IStyledProps>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ loading }) => (loading && 'center') || 'flex-start'};
  align-items: center;
  flex-grow: 1;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 60%;
`;
const Heading = styled.h1``;
const Error = styled(FormHelperText)`
  color: ${({ theme }) => `${theme.colors.error} !important`};
  margin-bottom: 10px !important;
`;

type TProps = {
  stepLoading: boolean;
};

const UploadImages = ({ stepLoading }: TProps) => {
  const { setFieldValue, values, errors } = useFormikContext<FormikValues>();

  const handleImageUpload = useCallback(
    (val) => {
      setFieldValue('images', val);
    },
    [setFieldValue]
  );

  return (
    <Section loading={stepLoading}>
      <Container>
        <Heading>Upload Images</Heading>
        <Error>{errors?.images}</Error>
        <ImagesUploader onChangeHandler={handleImageUpload} images={values.images} />
      </Container>
    </Section>
  );
};

UploadImages.label = 'Upload Images';
UploadImages.validate = (values: FormikValues) => {
  const errors = {};
  if (values.images.length === 0) {
    // @ts-ignore
    errors.images = 'Select Images for Ad';
  }
  return errors;
};
UploadImages.initialValues = {
  images: [],
};

export default UploadImages;
